import { LOCALE_EN_GB, LOCALE_EN_US } from "../constants/constants";
import type { Locale } from "../types";

export const formatDateByLocale = (
  date: string,
  locale: Locale = LOCALE_EN_GB,
): string => {
  const [year, month, day] = date.split("-");

  if (locale === LOCALE_EN_US) {
    return `${month}/${day}/${year}`;
  }
  // Default to en-GB format
  return `${day}/${month}/${year}`;
};

export const toISODate = (date: string, locale: Locale = LOCALE_EN_GB) => {
  if (locale === LOCALE_EN_GB) {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
  }

  const [month, day, year] = date.split("/");
  return `${year}-${month}-${day}`;
};
